module.exports = ".kan-user-dialog-container {\n  font-size: 13px;\n  padding: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/modules/admin/dialogs/user-dialog/component.scss
// module id = ./src/modules/admin/dialogs/user-dialog/component.scss
// module chunks = main